import { Button, Group, Modal, Text } from "@mantine/core";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";

interface DownloadConfirmationModalProps {
  onCancel: () => void;
  onDownload: () => void;
  onDownloadWithUpload: () => void;
  downloadLoading: boolean;
  downloadWithUploadLoading: boolean;
}

function DownloadConfirmationModal({
  onCancel,
  onDownload,
  onDownloadWithUpload,
  downloadLoading,
  downloadWithUploadLoading
}: DownloadConfirmationModalProps) {
  return (
    <Modal
      opened
      size="lg"
      title="Messkonzeptdokument herunterladen"
      onClose={onCancel}
    >
      <Text>
        Ihr Messkonzept kann jetzt heruntergeladen werden. Wir empfehlen, das
        Dokument direkt auf der Aufgabe 3.1. „Messkonzept vorbereiten“ der
        zugehörigen Liegenschaft zu hinterlegen. Klicken Sie dafür auf{" "}
        <i>Herunterladen und Ablegen</i>.
      </Text>
      <ModalFooter justify="space-between">
        <Button variant="default" onClick={onCancel}>
          Abbrechen
        </Button>

        <Group>
          <Button
            color="primary"
            disabled={downloadLoading || downloadWithUploadLoading}
            loading={downloadLoading}
            onClick={() => onDownload()}
          >
            Herunterladen
          </Button>

          <Button
            color="secondary"
            disabled={downloadLoading || downloadWithUploadLoading}
            loading={downloadWithUploadLoading}
            onClick={() => onDownloadWithUpload()}
          >
            Herunterladen und Ablegen
          </Button>
        </Group>
      </ModalFooter>
    </Modal>
  );
}

export { DownloadConfirmationModal };
